<template>
  <div class="d-c">
    <div class="flex-a-c">
      <span>{{ $t('ctcdd2') }}</span>
      <el-slider v-model="voice" style="width: 120px;" @change="(val) => { setValue('voice', val / 100) }"></el-slider>
      <div style="width:30px">{{ voice }}</div>
    </div>
    <div class="flex-a-c">
      <span>{{ $t('ctcdd1') }}</span>
      <el-slider v-model="bright" style="width: 120px;" @change="(val) => { setValue('bright', val) }"></el-slider>
      <div style="width:30px">{{ bright }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceControl',
  props: {
    currentDetail: {
      type: Object,
      default: null
    },
    deviceInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      voice: 0,
      bright: 0
    }
  },
  methods: {
    setValue(type, value) {

      const { id, sn } = this.currentDetail;
      let data = [{ device_id: id, sn, msg: { id, data: { value: value }, type: type } }];

      this.$http.post("/admin/command/deviceCommand", {
        commands_info: encodeURIComponent(JSON.stringify(data)),
      }, () => { });
    },
  },
  watch: {
    deviceInfo() {
      const { voice, bright } = this.deviceInfo;
      this.voice = voice * 100;
      this.bright = bright;
    },
  }
}
</script>

<style lang="scss" scoped>
.d-c {
  width: 100%;
  height: 100%;
}
</style>